import React, { useState } from 'react';

import { Button, Group, Modal, Stack, TextInput } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';

import { trpc } from '../lib/trpc';

interface LogModalProps {
  opened: boolean;
  onClose: () => void;
}

export function LogModal({ opened, onClose }: LogModalProps) {
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const createLogMutation = useMutation(
    trpc.tasks.createLog.mutationOptions({
      onSuccess: () => {
        setMessage('');
        onClose();
      },
      onError: (error) => {
        console.error('Failed to create log task:', error);
      },
    }),
  );

  const handleSubmit = async () => {
    if (!message.trim()) return;

    setIsLoading(true);
    try {
      await createLogMutation.mutateAsync({
        message: message.trim(),
        payload: {},
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = async (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      await handleSubmit();
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Debug Log" size="md">
      <Stack gap="md">
        <TextInput
          label="Message"
          placeholder="Enter log message..."
          value={message}
          onChange={(event) => setMessage(event.currentTarget.value)}
          onKeyDown={handleKeyPress}
          autoFocus
        />

        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} loading={isLoading} disabled={!message.trim()}>
            Submit
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
